// src/belediye/hooks/useFeatureEnabled.js
// Özellik-flag aç/kapa kapısı (frontend yüzü) — /me.enabled_features'tan okur.
//
// Kural: yalnız AÇIKÇA false ise kapalı say (undefined/eksik → açık) —
// useModuleEnabled ile AYNI felsefe. Backend zaten gerçek kapı (izin kodu
// üretmez + motor/yazma kilidi); bu kanca yalnız İZ bırakmamak için UI gizler.
//
// Kullanım: const serbest = useFeatureEnabled("mesajlasma.serbest");

import { useSelector } from "react-redux";

import { selectEnabledFeatures } from "../redux/slices/authzSlice";

export function isFeatureEnabled(features, key) {
  if (!features) return true;
  return features[key] !== false;
}

export default function useFeatureEnabled(key) {
  const features = useSelector(selectEnabledFeatures);
  return isFeatureEnabled(features, key);
}
